import { render, staticRenderFns } from "./MedicationsCard.vue?vue&type=template&id=6f205f26&scoped=true"
import script from "./MedicationsCard.vue?vue&type=script&lang=js"
export * from "./MedicationsCard.vue?vue&type=script&lang=js"
import style0 from "./MedicationsCard.vue?vue&type=style&index=0&id=6f205f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f205f26",
  null
  
)

export default component.exports